<ng-template #drawingToolsPanel>
  <div class="tt-trace-drawingtools tt-animate-transition" (@openClose.start)="onAnimationEventStart($event)"
    (@openClose.done)="onAnimationEventEnd($event)" [@openClose]="isOpen() ? 'open' : 'close'">
    <!-- PHONE -->
    @if (browserSniffer.isPhone()) {
      <div style="display:contents">
        <div class="tool-toggle-btns-wrapper  container-flex-end">
          <!-- -->
          <!-- <div class="tool-toggle-info-container"> -->
          <!-- <a class="autoRouting" *ngIf="traceDrawerTools.value === 'ROUTE'">
          <mat-checkbox class="autoRouting" [checked]="traceService.autoRouting()"
            (change)="drawingToolAction({action:'setAutoRouting',value:$event.checked?'true':'false'})">{{"trace.create-route.auto-routing"
          | translate }}</mat-checkbox>
        </a> -->
        <!-- <span *ngIf="traceDrawerTools.value === 'ROUTE'">{{"trace.create-route.tool-info-route" | translate }}</span> -->
        <!-- <span *ngIf="traceDrawerTools.value === 'POI'">{{"trace.create-route.tool-info-poi" | translate }}</span> -->
        <!-- <span *ngIf="traceDrawerTools.value === 'PAUSE'">{{"trace.create-route.tool-info-pause" | translate }}</span> -->
        <!-- <-->
        <!-- <span style="padding-left: 32px; color: #47a7d2;">|</span>
        <mat-divider [vertical]="true"></mat-divider>  -->
      <!-- </div> -->
      <!-- 1 toggle buttons -->
      <div class="tool-toggle-btns-container">
        <mat-button-toggle-group hideSingleSelectionIndicator="true" [vertical]="true" name="traceDrawerTools"
          aria-label="drawing tool selection" #traceDrawerTools="matButtonToggleGroup" [value]="activeDrawingTool()"
          (change)="drawingToolAction({action:'setDrawertool',value:traceDrawerTools.value})"
          [disabled]="activeDrawingToolDisabled()">
          <mat-button-toggle value="ROUTE" [matTooltip]="'trace.create-route.tool-title-route' | translate"
            matTooltipPosition="above">
            <mat-icon>polyline</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="POI" [matTooltip]="'trace.create-route.tool-title-poi' | translate"
            matTooltipPosition="above">
            <mat-icon>location_on</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <div class="btn-command-container" style="margin-top:10px">
      <button mat-mini-fab class="btn-command" [ngClass]="{'checked' :traceService.autoRouting()}"
        (click)="drawingToolAction({action:'setAutoRouting',value:traceService.autoRouting() ?'false':'true'})"
        [matTooltip]="'trace.create-route.auto-routing' | translate" matTooltipPosition="above">
        <!-- <span class="mat-button-wrapper"> -->
        <mat-icon fontSet="ngi" fontIcon="snap"></mat-icon>
      <!-- </span> -->
    </button>
  </div>
  <div class="tool-btns-container">
    <!-- undo/redos btns -->
    <!-- <div style="display:inline-flex;width:15px"></div> -->
    <div class="btn-command-container btn-undo-container">
      <button mat-mini-fab class="btn-command undo" aria-label="drawing tool undo" color="primary"
        (click)="drawingToolAction({action:'undoLastChange',value:''})"
        [matTooltip]="'trace.create-route.tool-title-undo' | translate" matTooltipPosition="above"
        [disabled]="!traceCreateUndoService.canUndoLastChange()">
        <!-- <span class="mat-button-wrapper"> -->
        <mat-icon>undo</mat-icon>
        <!-- <div class="btn-command-label">{{"trace.undo"|translate}}</div> -->
      <!-- </span> -->
    </button>
    <button mat-mini-fab class="btn-command redo" aria-label="drawing tool redo" color="primary"
      (click)="drawingToolAction({action:'redoLastChange',value:''})"
      [matTooltip]="'trace.create-route.tool-title-redo' | translate" matTooltipPosition="above"
      [disabled]="!traceCreateUndoService.canRedoLastChange()">
      <!-- <span class="mat-button-wrapper"> -->
      <mat-icon>redo</mat-icon>
      <!-- <div class="btn-command-label">{{"trace.redo"|translate}}</div> -->
    <!-- </span> -->
  </button>
</div>
<div class="btn-command-container" style="margin-top:10px">
  <button mat-mini-fab class="btn-command" color="primary"
    [ngClass]="{'mat-button-disabled': !isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap() && !ref_isRouteWithGeneralInfo()) }"
    [disabled]="!isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap() && !ref_isRouteWithGeneralInfo())"
    (click)="resetMapData()" [matTooltip]="'trace.create-route.tool-title-clear-all' | translate"
    matTooltipPosition="above">
    <!-- <span class="mat-button-wrapper"> -->
    <mat-icon>delete</mat-icon>
  <!-- </span> -->
</button>
</div>
<button mat-icon-button class="elevation-drawing-tools-btn" (click)="traceService.toggleElevationProfile();"
  [matTooltip]="isElevationProfileOpen() ? ('trace.hide-profile-tooltip' | translate):'trace.show-profile-tooltip' | translate"
  matTooltipPosition="left">
  <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
</button>
</div>
<!-- ready button -->
<div class="ready-draw-btn" (click)="doneDrawingMobile()">
  <div class="btn-command-container">
    <!-- <button style="top: -6px" mat-icon-button class="btn-command" color="accent" -->
    <button mat-fab class="btn-command orange-button"
      [matTooltip]="'trace.create-route.tool-title-done-drawing' | translate" matTooltipPosition="above">
      <span class="mat-button-wrapper">
        <mat-icon>done</mat-icon>
        <!-- <div class="btn-command-label">{{"trace.done-drawing"|translate}}</div> -->
      </span>
    </button>
  </div>
</div>
</div>
}

<!-- DESKTOP -->


@if (!browserSniffer.isPhone()) {
  <div style="display:contents">
    <div class="tool-toggle-btns-wrapper  container-flex-end">
      <!-- -->
      <div class="tool-toggle-info-container">
        &nbsp;
        @if (traceDrawerTools.value === 'ROUTE') {
          <a class="autoRouting">
            <mat-checkbox class="autoRouting orange-checkbox" [checked]="traceService.autoRouting()"
              (change)="drawingToolAction({action:'setAutoRouting',value:$event.checked?'true':'false'})">{{"trace.create-route.auto-routing"
            | translate }}</mat-checkbox>
          </a>
        }
        <!-- <span *ngIf="traceDrawerTools.value === 'ROUTE'">{{"trace.create-route.tool-info-route" | translate }}</span> -->
        @if (traceDrawerTools.value === 'POI') {
          <span>{{"trace.create-route.tool-info-poi" | translate }}</span>
        }
        @if (traceDrawerTools.value === 'PAUSE') {
          <span>{{"trace.create-route.tool-info-pause" | translate }}</span>
        }
        <!-- <-->
        <!-- <span style="padding-left: 32px; color: #47a7d2;">|</span>
        <mat-divider [vertical]="true"></mat-divider>  -->
      </div>
      <!-- 1 toggle buttons -->
      <div class="tool-toggle-btns-container">
        <mat-button-toggle-group hideSingleSelectionIndicator="true" name="traceDrawerTools"
          aria-label="drawing tool selection" #traceDrawerTools="matButtonToggleGroup" [value]="activeDrawingTool()"
          (change)="drawingToolAction({action:'setDrawertool',value:traceDrawerTools.value})"
          [disabled]="activeDrawingToolDisabled()">
          <mat-button-toggle value="ROUTE" [matTooltip]="'trace.create-route.tool-title-route' | translate"
            matTooltipPosition="below">
            <mat-icon>polyline</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="POI" [matTooltip]="'trace.create-route.tool-title-poi' | translate"
            matTooltipPosition="below">
            <mat-icon>location_on</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle value="PAUSE" [matTooltip]="'trace.create-route.tool-title-pause' | translate"
            matTooltipPosition="below">
            <mat-icon>pause</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
    <div class="tool-btns-container">
      <!-- 3 tools btns -->
      <!-- <div style="display:inline-flex;width:15px"></div> -->
      <div class="btn-command-container btn-undo-container">
        <button mat-icon-button class="btn-command" aria-label="drawing tool undo" color="primary"
          (click)="drawingToolAction({action:'undoLastChange',value:''})"
          [matTooltip]="'trace.create-route.tool-title-undo' | translate" matTooltipPosition="below"
          [disabled]="!traceCreateUndoService.canUndoLastChange()">
          <span class="mat-button-wrapper">
            <mat-icon>undo</mat-icon>
            <div class="btn-command-label">{{"trace.undo"|translate}}</div>
          </span>
        </button>
      </div>
      <div class="btn-command-container btn-undo-container">
        <button mat-icon-button class="btn-command redo" aria-label="drawing tool redo" color="primary"
          (click)="drawingToolAction({action:'redoLastChange',value:''})"
          [matTooltip]="'trace.create-route.tool-title-redo' | translate" matTooltipPosition="below"
          [disabled]="!traceCreateUndoService.canRedoLastChange()">
          <span class="mat-button-wrapper">
            <mat-icon>redo</mat-icon>
            <div class="btn-command-label">{{"trace.redo"|translate}}</div>
          </span>
        </button>
      </div>
      <!-- <div style="display:inline-flex;width:15px"></div> -->
      <div class="btn-command-container">
        <!--
        if we also delete the metdata during clear all, the test should be:
        !isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap() && !ref_isRouteWithGeneralInfo())
        -->
        <button mat-icon-button class="btn-command" color="primary"
          [ngClass]="{'mat-button-disabled': !isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap()) }"
          [disabled]="!isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap())" (click)="resetMapData()"
          [matTooltip]="'trace.create-route.tool-title-clear-all' | translate" matTooltipPosition="below">
          <span class="mat-button-wrapper">
            <mat-icon>delete</mat-icon>
            <div class="btn-command-label">{{"trace.clear-all"|translate}}</div>
          </span>
        </button>
      </div>
      <!-- <div style="display:inline-flex;width:15px"></div> -->
      <!--
      <div class="btn-command-container ready-btn-wrapper">
        <div class="ready-draw-btn" (click)="doneDrawing()"> -->
          <!--
          <div class="ready-draw-btn" (click)="doneDrawing()">
            <div class="btn-command-container">
              <button style="top: -6px" mat-icon-button class="btn-command" color="accent"
                [matTooltip]="'trace.create-route.tool-title-done-drawing' | translate" matTooltipPosition="below">
                <span class="mat-button-wrapper">
                  <mat-icon>done</mat-icon>
                  <div class="btn-command-label">{{"trace.done-drawing"|translate}}</div>
                </span>
              </button>
            </div>
          </div>  -->
          <div class="ready-draw-btn" (click)="doneDrawing()">
            <div class="btn-command-container">
              <button mat-fab extended class="btn-command orange-button"
                [matTooltip]="'trace.create-route.tool-title-done-drawing' | translate" matTooltipPosition="above">
                <mat-icon>done</mat-icon>
                {{"trace.done-drawing"|translate}}
              </button>
            </div>
          </div>
          <!-- <div class="ready-draw-btn" (click)="doneDrawing()">
          <div class="btn-command-container" style="width: 70px;position: relative;">
            <button mat-fab extended class="btn-command orange-button"
              [matTooltip]="'trace.create-route.tool-title-done-drawing' | translate" matTooltipPosition="above">
              <mat-icon>done</mat-icon>
              {{"trace.done-drawing"|translate}}
            </button>
          </div>
        </div> -->
        @if (browserSniffer.isDesktop) {
          <button mat-icon-button class="elevation-drawing-tools-btn"
            (click)="traceService.toggleElevationProfile();"
            [matTooltip]="isElevationProfileOpen() ? ('trace.hide-profile-tooltip' | translate):'trace.show-profile-tooltip' | translate"
            matTooltipPosition="left">
            <mat-icon fontSet="ngi" fontIcon="elevation-profile"></mat-icon>
          </button>
        }
      </div>
    </div>
  }

  <!-- [ngClass]="{'mat-button-disabled': !isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap()) }" [disabled]="!isActive() || (!ref_hasRouteOnMap() && !ref_hasWayPointsOnMap())"  -->
  <!-- <button style="margin:12px" mat-icon-button class="" (click)="traceService.openTraceTab(null);" *ngIf="traceService.isWatchingRouteWithoutDrawer() && traceService.isInEditingMode()" [matTooltip]="'trace.reopen-panel' | translate" matTooltipPosition="left">
  <mat-icon aria-label="reopen-routing">arrow_backward</mat-icon>
</button>  -->

</div>

</ng-template>